import { jsx as o } from "@emotion/react/jsx-runtime";
import { OverrideCalendar as a } from "./Calendar.styled.js";
import { useDatePickerContext as n } from "../DatePickerContext.js";
import { DatePickerInputName as i } from "../../../types/components/dateRangePicker.js";
const u = ({
  children: t
}) => {
  const {
    activeInput: r
  } = n(), e = r === i.StartDate;
  return /* @__PURE__ */ o(a, { startInputFocused: e, children: t });
};
export {
  u as Calendar
};
